import { Injectable } from '@angular/core';
import { EndpointConfig } from '../common/EndpointConfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SaveGInstallmentRequest, SaveInventoryTransfersRequest, SavePurchaseMasterRequest, SaveStockAdjustmentRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GPurchaseService {

  private _ep: EndpointConfig;
  constructor(private http: HttpClient) {
    this._ep = new EndpointConfig('');
  }





  public GetGPurchaseRefIdAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetGPurchaseRefIdAsync')}`);
  }

  public DeletePurchaseRequisiteAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GPurchase', 'DeletePurchaseRequisiteAsync')}/${id}`);
  }

  public SaveGPurchaseAsync(obj: SavePurchaseMasterRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GPurchase', 'SaveGPurchaseAsync')}`, obj);
  }

  public GetGPurchaseByIdAsync(id: string) {
    debugger
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetGPurchaseByIdAsync')}/${id}`);
  }

  public GetPurchaseExportAsync(fromDate: Date | string, toDate: Date | string) {
    const f = new Date(fromDate).toISOString().split('T')[0]; // yyyy-MM-dd
    const t = new Date(toDate).toISOString().split('T')[0];
    return this.http.get(
      `${this._ep.getControllerUrl('GPurchase', 'GetPurchaseExportAsync')}/${encodeURIComponent(f)}/${encodeURIComponent(t)}`
    );
  }

  GetPurchaseImportAsync(file: any) {
    debugger
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(`${this._ep.getControllerUrl('GPurchase', 'GetPurchaseImportAsync')}`, formData);
  }

  public GetGInstallmentByPurchaseIdAsync(id: string) {
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetGInstallmentByPurchaseIdAsync')}/${id}`);
  }

  SaveSpInstallmentAsync(obj: SaveGInstallmentRequest) {
    debugger
    const formData = new FormData();
    formData.append("file", obj.file);
    formData.append('Installment', JSON.stringify(obj));
    return this.http.post(`${this._ep.getControllerUrl('GPurchase', 'SaveSpInstallmentAsync')}`, formData);
  }

  public DeleteSpInstallmentAsync(id: string) {
    return this.http.delete(`${this._ep.getControllerUrl('GPurchase', 'DeleteSpInstallmentAsync')}/${id}`);
  }

  public GetStockAdjustmentByWarehouseIdAsync(id: number) {
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetStockAdjustmentByWarehouseIdAsync')}/${id}`);
  }

  public GetGStockAdjustmentRefIdAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetGStockAdjustmentRefIdAsync')}`);
  }

  public SaveStockAdjustmentAsync(obj: SaveStockAdjustmentRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GPurchase', 'SaveStockAdjustmentAsync')}`, obj);
  }

  public GetStockAdjustmentByIdAsync(id: number) {
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetStockAdjustmentByIdAsync')}/${id}`);
  }

  public GetInventoryTransfersAsync() {
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetInventoryTransfersAsync')}`);
  }

   public GetInventoryTransfersByWarehouseIdAsync(fromId: number, toId: number) {
    return this.http.get(`${this._ep.getControllerUrl('GPurchase', 'GetInventoryTransfersByWarehouseIdAsync')}/${fromId}/${toId}`);
  }

  public SaveGTransferInventoryAsync(obj: SaveInventoryTransfersRequest) {
    return this.http.post(`${this._ep.getControllerUrl('GPurchase', 'SaveGTransferInventoryAsync')}`, obj);
  }

  public getList(
    controller: string,
    action: string,
    page: number,
    size: number,
    searchObj: any = {},
    orderBy: string = 'Desc',
    sort: string = '',
    flag: string = ''
  ) {
    let params = new HttpParams()
      .set('Page', page.toString())
      .set('Size', size.toString());

    if (flag !== undefined && flag !== null && flag !== '') {
      params = params.set('Flag', flag.toString());
    }

    // Use Object.keys to iterate over the properties of searchObj
    Object.keys(searchObj).forEach(key => {
      const value = searchObj[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(`Search.${key}`, value.toString());
      }
    });

    if (orderBy) {
      params = params.set('OrderBy', orderBy);
    }
    if (sort) {
      params = params.set('Sort', sort);
    }

    return this.http.get(`${this._ep.getControllerUrl(controller, action)}`, { params });
  }



  public getListById(
    controller: string,
    action: string,
    page: number,
    size: number,
    searchObj: any = {},
    orderBy: string = '',
    sort: string = '',
    id?: string | number // add Id param here, optional
  ) {
    let params = new HttpParams()
      .set('Page', page.toString())
      .set('Size', size.toString());

    // Add Id if provided
    if (id !== undefined && id !== null && id !== '') {
      params = params.set('Id', id.toString());
    }

    // Use Object.keys to iterate over searchObj properties
    Object.keys(searchObj).forEach(key => {
      const value = searchObj[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(`Search.${key}`, value.toString());
      }
    });

    if (orderBy) {
      params = params.set('OrderBy', orderBy);
    }
    if (sort) {
      params = params.set('Sort', sort);
    }

    return this.http.get(`${this._ep.getControllerUrl(controller, action)}`, { params });
  }
}
